module.exports = __webpack_public_path__ + "static/media/Large_2016.835ff55f.svg";